// 根据 登录获取用户信息
// import { apiGet, apiPost, apiPatch } from './index'
import {apiGet, apiPost, apiPut} from './index'

// 获取兴趣列表
const interestTagList = (params) => apiGet('/api/johnson/interestTag/list', params)
// 提交兴趣列表
const interestTagSave = (params) => apiPost('/api/johnson/IepUserInterestTag/batchSave', params)
// 获取当前用户的兴趣列表
const iepUserInterestTag = (params) => apiGet(`/api/johnson/IepUserInterestTag/getByIepUserId/${params.iepUserId}`)
// 获取当前用户的兴趣列表
const iepUserInterest = (params) => apiGet(`/api/johnson/IepUserInterestTag/getByIepUserId/select/${params.iepUserId}`)
// 登录pc
const loginPc = (params) => apiPost(`/api/openapi/iep/loginPc`, params)

// 空岛模拟器登录
const loginSimulator = (params) => apiPost(`/api/openapi/iep/simulator/loginSimulator`, params)

// smart登录
const loginSmart = (params) => apiPost(`/api/smart`, params)

const updateActionStatusCode = (params) => apiPut(`/api/system/actions/update/${params.actionCode}/${params.actionStatus}`)
const getActionStatusCode = (params) => apiGet(`/api/system/actions/status/${params.actionCode}`)

// 获取浏览历史
// 文献
const docuBrowseHistory = (params) => apiGet(`/api/userCourseLog/docuBrowseHistory`, params)
// 病例
const caseBrowseHistory = (params) => apiGet(`/api/userCourseLog/caseBrowseHistory`, params)
// 课程
const courseBrowseHistory = (params) => apiGet(`/api/userCourseLog/courseBrowseHistory`, params)

// 判断是否有过远程
const getUserUserhospauthrecord = (params) => apiGet(`/api/johnson/iep/users/getUserUserhospauthrecord`, params)
// 绑定远程
const authHosp = (params) => apiPost(`/api/johnson/iep/users/authHosp`, params)

// 勋章列表
const getUserMedal = (params) => apiGet(`/api/userMedal/listPhone`, params)
// 获取积分
const getUserCostTotal = (params) => apiGet(`/api/userGetCost/getUserCostTotal`, params)
// 获取积分列表
const getUserCost = (params) => apiGet(`/api/userGetCost/listPagePhone`, params)
// 积分消费列表
const getUserUseCost = (params) => apiGet(`/api/sys/resource/unlock`, params)
// 用户满足晋升勋章条件
const getMyMedalUpgrade = (params) => apiGet(`/api/userMedal/myMedalUpgrade?userId=${params.iepUserId}`, params)
// 绑定远程
const updateMedalIsShow = (params) => apiPost(`/api/userMedal/updateMedalIsShow?id=${params.id}`, params)

// 用户远程带教授权医院列表
const queryListByUserId = (params) => apiGet(`/api/system/serhospauthrecord/queryListByUserId`, params)

// 用户授权远程带教授权医院
const addUserhospauth = (params) => apiPost(`/api/system/serhospauthrecord/addUserhospauth`, params)

// 获取用户是否授权医院
const getAuthStatus = (params) => apiGet(`/api/system/serhospauthrecord/getAuthStatus`, params)
// 用户解绑授权医院
const relieveByUserId = (params) => apiGet(`/api/system/serhospauthrecord/relieveByUserId`, params)

// Carto远程服务声明
const getDataDictionary = (params) => apiGet(`/api/openapi/wx/dataDictionary`, params)

// 内容收藏
const userMyCollect = (params) => apiGet(`/api/userCollect/myQueryPage`, params)
const liveCollect = (params) => apiGet(`/api/userCourseLog/liveCollect`, params)
const docuCollect = (params) => apiGet(`/api/userCourseLog/docuCollect`, params)
const caseCollect = (params) => apiGet(`/api/userCourseLog/caseCollect`, params)

// 直播
const listPageMobile = (params) => apiGet(`/api/live/listPageMobileMy`, params)

export {
  interestTagList,
  interestTagSave,
  iepUserInterestTag,
  iepUserInterest,
  loginPc,
  loginSimulator,
  loginSmart,
  getActionStatusCode,
  updateActionStatusCode,
  docuBrowseHistory,
  caseBrowseHistory,
  courseBrowseHistory,
  getUserUserhospauthrecord,
  authHosp,
  getUserMedal,
  getUserCostTotal,
  getUserCost,
  getUserUseCost,
  getMyMedalUpgrade,
  updateMedalIsShow,
  userMyCollect,
  liveCollect,
  docuCollect,
  caseCollect,
  queryListByUserId,
  addUserhospauth,
  relieveByUserId,
  getAuthStatus,
  getDataDictionary,
  listPageMobile,
}



// WEBPACK FOOTER //
// ./src/api/person.js